var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41421 1.58579C2.63317 0.804738 1.36683 0.804738 0.585786 1.58579C-0.195262 2.36683 -0.195262 3.63317 0.585786 4.41421L4.17157 8L0.585786 11.5858C-0.195262 12.3668 -0.195262 13.6332 0.585786 14.4142C1.36683 15.1953 2.63317 15.1953 3.41421 14.4142L7 10.8284L10.5858 14.4142C11.3668 15.1953 12.6332 15.1953 13.4142 14.4142C14.1953 13.6332 14.1953 12.3668 13.4142 11.5858L9.82843 8L13.4142 4.41421C14.1953 3.63317 14.1953 2.36683 13.4142 1.58579C12.6332 0.804738 11.3668 0.804738 10.5858 1.58579L7 5.17157L3.41421 1.58579Z",
    fill: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModalIcon);
export default __webpack_public_path__ + "static/media/closeModalIcon.a6a5635e1edb61a8b45d101ddc610c30.svg";
export { ForwardRef as ReactComponent };